import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import posthog from '../posthog'
import { useAuth } from './useAuth'

export default function usePostHogTracking() {
    const location = useLocation()
    const { isAdmin } = useAuth()
    useEffect(() => {
        //Prevent tracking if user is connected as or posthog not loaded
        if (!posthog.__loaded || isAdmin) return
        const location_path = location.pathname
        posthog.capture('$pageview', { path: location_path })
        console.log('Page tracked Post hog :' + location_path)
    }, [location, posthog.__loaded])

    return null
}